import { callForHelp } from './call-for-help/call-for-help.module';
import { ridesharing } from './ridesharing/ridesharing.module';
import { bicyclePedestrian } from './bicycle-pedestrian/bicycle-pedestrian.module';
import { transportationProviders } from './transportation-providers/transportation-providers.module';
import { TransportationAlternativeService } from './transportation-alternative.service';
import './transportation-alternative.scss';

export const transportationAlternative = angular
	.module('components.transportationAlternative', [
		callForHelp,
		ridesharing,
		bicyclePedestrian,
		transportationProviders
	])
	.service('TransportationAlternativeService', TransportationAlternativeService)
	.name;



// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/transportation-alternative.module.js